<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Utenti',
      link: '/utenti'
    }, {
      label: form.uuid ? 'Modifica Utente' : 'Aggiungi nuovo Utente'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.firstname"
      :error-fields="errorFields"
      name="firstname"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <InputText
      v-model="form.lastname"
      :error-fields="errorFields"
      name="lastname"
      :submitted="submitted"
    >
      Cognome
    </InputText>

    <InputText
      v-model="form.email"
      :disabled="form.uuid"
      :error-fields="errorFields"
      name="email"
      :submitted="submitted"
    >
      Email
    </InputText>

    <CompanyInputSelect
      v-model="form.companyUuid"
      :error-fields="errorFields"
      name="companyUuid"
      :submitted="submitted"
    />

    <InputBoolean
      v-model="form.notificationEnabled"
      :error-fields="errorFields"
      name="notificationEnabled"
      :submitted="submitted"
    >
      Notifiche attive?
    </InputBoolean>

    <h4 class="uppercase text-sm mb-4 mt-8 font-bold">
      Informazioni addizionali
    </h4>

    <InputText
      v-model="form.attributes.address"
      :error-fields="errorFields"
      name="attributes.address"
      :submitted="submitted"
    >
      Indirizzo
    </InputText>

    <InputText
      v-model="form.attributes.city"
      :error-fields="errorFields"
      name="attributes.city"
      :submitted="submitted"
    >
      Città
    </InputText>

    <InputText
      v-model="form.attributes.phone"
      :error-fields="errorFields"
      name="attributes.phone"
      :submitted="submitted"
    >
      Telefono
    </InputText>

    <InputText
      v-model="form.attributes.fax"
      :error-fields="errorFields"
      name="attributes.fax"
      :submitted="submitted"
    >
      Fax
    </InputText>

    <InputTextarea
      v-model="form.notes"
      :error-fields="errorFields"
      name="notes"
      :submitted="submitted"
    >
      Note
    </InputTextarea>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>
  
<script setup>
import { reactive, toRef } from 'vue'

import CompanyInputSelect from '@/components/form/CompanyInputSelect.vue';
import InputBoolean from '@/components/form/InputBoolean.vue';
import InputText from '@/components/form/InputText.vue';
import InputTextarea from '@/components/form/InputTextarea.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import useForm from '@/composables/form';

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  }
})

const axios = useAxios()

let form = reactive({
  firstname: null,
  lastname: null,
  email: null,
  companyUuid: null,
  notificationEnabled: true,
  notes: '',
  attributes: {
    address: null,
    city: null,
    phone: null,
    fax: null
  },
})

if (props.id) {
  const resp = await axios.get('/auction-user/' + props.id);
  if(!resp.data.attributes) {
    resp.data.attributes = {};
  }
  form = reactive(resp.data);
}

const companiesResp = await axios.get('/company/list')
const companies = companiesResp.data.map((company) => {
  return {
    id: company.uuid,
    label: company.name
  }
})

const rules = {
  firstname: {
    type: 'string',
    max: 128,
    required: true
  },
  lastname: {
    type: 'string',
    max: 128,
    required: true
  },
  email: {
    type: 'email',
    max: 255,
    required: true
  },
  companyUuid: {
    type: 'string',
    required: true
  }
}
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'auction-user', rules, {
  create: 'Utente creato con successo',
  update: 'Utente modificato con successo'
}, '/utenti', () => {
  form.firstname = null;
  form.lastname = null;
  form.email = null;
  form.companyUuid = null;
  form.notificationEnabled = true;
  form.notes = '';

  form.attributes.address = null;
  form.attributes.city = null;
  form.attributes.phone = null;
  form.attributes.fax = null;
  
})

</script>
   
